<template>
  <el-tabs v-model="activeTab">
    <el-tab-pane :label="$t('orders.tabs.uploadMenuTitle')" name="upload">
      <upload-menu @officechanged="onOfficeChanged" />
    </el-tab-pane>
    <el-tab-pane :label="$t('orders.tabs.totalsTitle')" name="totals">
      <orders-totals @officechanged="onOfficeChanged" @companychanged="onCompanyChanged" />
    </el-tab-pane>
    <el-tab-pane :label="$t('orders.tabs.individualListTitle')" name="individual">
      <individual-list @officechanged="onOfficeChanged" @companychanged="onCompanyChanged" />
    </el-tab-pane>
    <el-tab-pane :label="$t('orders.tabs.totalsByUsersTitle')" name="totals-by-users">
      <totals-by-user />
    </el-tab-pane>
    <el-tab-pane :label="$t('orders.tabs.userUploaderTitle')" name="upload-user">
      <upload-user-tab @officechanged="onOfficeChanged" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import IndividualList from '@/components/orders/IndividualList';
import OrdersTotals from '@/components/orders/OrdersTotals';
import TotalsByUser from '@/components/orders/TotalsByUser';
import UploadMenu from '@/components/orders/UploadMenu';
import UploadUserTab from '@/components/UploadUserTab';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'OrdersTab',
  components: {
    UploadMenu,
    OrdersTotals,
    TotalsByUser,
    IndividualList,
    UploadUserTab,
  },
  data() {
    return {
      activeTab: 'upload',
    };
  },
  computed: {
    ...mapState('weeklyMenu', { weekNumber: (state) => state.weekNumber }),
    ...mapState('global', { adminSelectedOffice: 'adminSelectedOffice' }),
  },
  methods: {
    ...mapActions('global', {
      setAdminSelectedOffice: 'setAdminSelectedOffice',
      setAdminSelectedCompany: 'setAdminSelectedCompany',
    }),
    ...mapActions('orders', { initializeWeekOrders: 'initializeWeekOrders' }),
    onOfficeChanged(office) {
      this.setAdminSelectedOffice({ office });
    },
    onCompanyChanged(company) {
      this.setAdminSelectedCompany({ company });
    },
    updateOrdersByWeek() {
      this.initializeWeekOrders({ office: this.adminSelectedOffice, weekNumber: this.weekNumber });
    },
  },
  watch: {
    weekNumber() {
      this.updateOrdersByWeek();
    },
    adminSelectedOffice() {
      this.updateOrdersByWeek();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/orders/OrdersTab.vue